/**
 * Portfolio block client scripts.
 *
 * @package Drivn\Theme
 */

const filterNav = document.querySelector( '.portfolio__filter' );
const sectionsWrapper = document.querySelector( '.portfolio__sections' );
const sections = document.querySelectorAll( '[data-portfolio-client]' );

if ( filterNav && sections.length && sectionsWrapper ) {
	filterNav.addEventListener( 'click', function( event ) {
		const button = event.target.closest( '[data-portfolio-filter]' );

		if ( ! button ) {
			return;
		}

		const filter = button.getAttribute( 'data-portfolio-filter' );

		filterNav.querySelectorAll( '[data-portfolio-filter]' ).forEach( function( btn ) {
			btn.classList.remove( 'is-active' );
		} );
		button.classList.add( 'is-active' );

		sections.forEach( function( section ) {
			const match = filter === 'all' || section.getAttribute( 'data-portfolio-client' ) === filter;

			if ( match ) {
				section.style.display = '';
				section.removeAttribute( 'aria-hidden' );
			} else {
				section.style.display = 'none';
				section.setAttribute( 'aria-hidden', 'true' );
			}
		} );

		if ( typeof AOS !== 'undefined' ) {
			AOS.refresh();
		}
	} );
}
